import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import { PATH } from '../config';
import { useBootStraps } from '../services/use-bootstraps';

interface EnterpriseJkoWrapperProps {
  children: React.ReactNode;
}

const ALLOWED_PATHS = [PATH.MAPS];

const checkIsAllowedPath = (path: string) =>
  ALLOWED_PATHS.some((p) => path.includes(p));

export const EnterpriseJkoWrapper = ({
  children,
}: EnterpriseJkoWrapperProps) => {
  useBootStraps();
  const [hasCheckRouting, setHasCheckRouting] = useState<boolean>(false);
  const { asPath, replace, push, query } = useRouter();

  useEffect(() => {
    async function checkPath() {
      if (hasCheckRouting) return;

      if (!checkIsAllowedPath(asPath)) {
        await replace(PATH.EXPIRED);
        setHasCheckRouting(true);
        return;
      }

      // FIXME: This is a weird workaround to fix the problem that the page gets 404 while first accessing the page
      replace(asPath);
      setHasCheckRouting(true);
    }

    checkPath();
  }, [asPath, push, replace, hasCheckRouting, query]);

  if (!hasCheckRouting) {
    return null;
  }

  return children;
};
